import React from 'react';
import { DisneyLogoImg, DisneyLogoWrapper, DisneyPartnershipContentContainer, OutdoorSportsHeaderText, OutdoorSportsWithDisneySectionWrapper } from './commonStyles';
import styled from 'styled-components';

export const DisneyWeatherPartnershipSection = () => {
    return (
        <DisneyPartnershipContentContainer>
            <OutdoorSportsWithDisneySectionWrapper>
                <WeatherBugLogoWrapper>
                    <WeatherBugLogo alt='WeatherBug Logo' src='/images/weatherbug-logo-horizontal.svg' />
                </WeatherBugLogoWrapper>
                <DisneyLogoWrapper href='https://disneysynclink.com/weathermonitoring/' target='_blank'>
                    <DisneyLogoImg alt='Disney Weather Check' src='/images/disney-weather-check-logo.png' />
                </DisneyLogoWrapper>
            </OutdoorSportsWithDisneySectionWrapper>
            {/* Tech debt: leaving the disney text here instead of coding it into translate.js file. All translate object in the file is shipped to pages that may not care about this text */}
            <TextContent>
                The WeatherBug solution is an innovative product that combines Disney’s technical expertise with WeatherBug’s technology platform to provide companies with top-of-the-line tools for weather tracking. <DisneyLink target='blank' href='https://disneysynclink.com/weathermonitoring/'>Learn More</DisneyLink> 
            </TextContent>
        </DisneyPartnershipContentContainer>
    );
};

const TextContent = styled.p`
    display: block;
    width: 100%;
    height: auto;
    font-family: "Source Sans Pro";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    color: #555;
    padding: 13px;
    text-align: left;
`;

const DisneyLink = styled.a`
    color: #555;
`;

const WeatherBugLogoWrapper = styled.div`
    display: flex;
    width: 109.333px;
    height: 29.5px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
`;

const WeatherBugLogo = styled.img`
    width: 100%;
    height: 100%;
    flex-shrink: 0;
`;